export function initFormSubmitValidation(): void {
    document.querySelectorAll<HTMLFormElement>('form').forEach((form) => {
        form.addEventListener('invalid', (event) => {
            event.preventDefault();
            form.classList.add('was-validated');
        }, true);
    });
}
